var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29688 1.99491V4.99491M1.29688 4.99491H4.29688M1.29688 4.99491L3.61687 2.81491C4.15425 2.27727 4.81906 1.88451 5.54928 1.6733C6.2795 1.46208 7.05132 1.43929 7.79273 1.60704C8.53414 1.77479 9.22097 2.12763 9.78914 2.63262C10.3573 3.13761 10.7883 3.7783 11.0419 4.49491M12.2969 9.99491V6.99491M12.2969 6.99491H9.29688M12.2969 6.99491L9.97688 9.17491C9.4395 9.71255 8.77469 10.1053 8.04447 10.3165C7.31425 10.5277 6.54243 10.5505 5.80102 10.3828C5.05961 10.215 4.37278 9.86219 3.80461 9.3572C3.23644 8.85221 2.80546 8.21152 2.55187 7.49491",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.c0e17d52de87215c439eb27c6c277ee0.svg";
export { ForwardRef as ReactComponent };